<div
  class="ng-gencat-dropdown-container"
  appClickOutside
  (clickOutside)="close()"
  #triggerRef
>
  <div class="ng-gencat-dropdown-trigger" (click)="toggle()">
    <ng-content select="[dropdownTrigger]"></ng-content>
  </div>
  @if (isOpen()) {
    <div
      #dropdownContent
      class="ng-gencat-dropdown-content"
      [ngClass]="[
        'ng-gencat-dropdown--' + position,
        'ng-gencat-dropdown-x--' + horizontal,
      ]"
      [style.maxHeight.px]="dropdownMaxHeight"
    >
      <ng-content select="[dropdownContent]"></ng-content>
    </div>
  }
</div>
